import { Engine1Proxy } from 'com-gyf-webcore-servicehub';
import GlobalHelper from '../Helpers/GlobalHelper';
let existente;

let ClienteManager = function () {

    /**
     * 
     * @param {any} tarjetas
     * @param {any} dispatch
     */
    function _actualizarStateVistaCliente(tarjetas, dispatch) {
        if (!tarjetas.clienteResultadoBusqueda.Id) {

            let parameter = {
                'NRO_DOC': tarjetas.cliente.Cuit
            }

            Engine1Proxy.AddDataSourcesRequests(parameter, 'GET_CLIENTE_DOC', 'Get', 'Tarjetas', 'CONSULTASOCIOS', 1, 'Product');
            Engine1Proxy.Execute((data) => _getClienteByDocResult(data, tarjetas, dispatch), null, null, "CONSULTASOCIOS");
        }
    }

    /**
     * 
     * @param {any} data
     * @param {any} tarjetas
     * @param {any} dispatch
     */
    function _getClienteByDocResult(data, tarjetas, dispatch) {
        let clienteResult = JSON.parse(data.GET_CLIENTE_DOC).Recordset0.Rows[0];
        if (!clienteResult) {
            return;
        }

        tarjetas.cliente.Id = clienteResult.Id;
        tarjetas.clienteResultadoBusqueda.Id = clienteResult.Id;
        dispatch({ type: "SET_STATE_FROM_VIGENTE", data: tarjetas });
        dispatch({ type: "ACTUALIZAR_ESTADO_GLOBAL_CLIENT_SEARCH", cliente: tarjetas.clienteResultadoBusqueda });
    }

    return {
        ActualizarStateVistaCliente: function (tarjetas, dispatch) {
            return _actualizarStateVistaCliente(tarjetas, dispatch);
        }
    }
};
let clienteManager = new ClienteManager();
export default clienteManager;